/*
 * @Author: ken yang
 * @Date: 2022-09-11 16:30:11
 * @LastEditTime: 2024-12-02 15:00:32
 * @LastEditors: zheng zheng@sense.sg
 * @Description:
 * @FilePath: /nicee-web-tw/src/router/router-activity.js
 */
export default [
  // {
  //   path: '/crystal-draw',
  //   name: 'crystalDraw',
  //   component: () => import('@/activities/crystal-draw/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // {
  //   path: '/national-Day-activities',
  //   name: 'nationalDayActivities',
  //   component: () => import('@/activities/national-Day-activities/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  {
    path: '/candies-draw',
    name: 'candiesDraw',
    component: () => import('@/activities/candies-draw/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true
    }
  },
  // // 萬聖節糖果抽獎
  // {
  //   path: '/halloween-draw',
  //   name: 'halloweenDraw',
  //   component: () => import('@/activities/halloween-draw/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 周星活動預熱
  // {
  //   path: '/starweek-preheat',
  //   name: 'starweekPreheat',
  //   component: () => import('@/activities/starweek-preheat/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 雙十一儲值活動
  // {
  //   path: '/double-eleven',
  //   name: 'doubleEleven',
  //   component: () => import('@/activities/double-eleven/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 水晶活動四期
  // {
  //   path: '/crystal-fourth',
  //   name: 'crystalFourth',
  //   component: () => import('@/activities/crystal-fourth/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 世界杯活动
  // {
  //   path: '/world-cup',
  //   name: 'worldCup',
  //   component: () => import('@/activities/world-cup/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 聖誕節活動
  // {
  //   path: '/christmas',
  //   name: 'christmas',
  //   component: () => import('@/activities/christmas/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 聖誕節活動開獎
  // {
  //   path: '/christmas-draw',
  //   name: 'ChristmasDraw',
  //   component: () => import('@/activities/christmas-draw/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 元旦节活动
  // {
  //   path: '/new-year',
  //   name: 'newYear',
  //   component: () => import('@/activities/new-year/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 新春活动
  // {
  //   path: '/spring-festival',
  //   name: 'SpringFestival',
  //   component: () => import('@/activities/spring-festival/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 情人節活动
  // {
  //   path: '/valentine-day-2023',
  //   name: 'ValentineDay',
  //   component: () => import('@/activities/valentine-day2/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 情人節活动
  // {
  //   path: '/valentine-day-0314',
  //   name: 'WhiteValentineDay',
  //   component: () => import('@/activities/white-valentine-day/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 语音房告解活动
  // {
  //   path: '/voice-room-confess',
  //   name: 'voiceRoomConfess',
  //   component: () => import('@/activities/voice-room-confess/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 520活动
  // {
  //   path: '/love520',
  //   name: 'Love520',
  //   component: () => import('@/activities/love-520/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 积分排名活动
  // {
  //   path: '/score-board',
  //   name: 'Scoreboard',
  //   component: () => import('@/activities/score-board/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // 糖果排名活动
  {
    path: '/candies-draw2',
    name: 'CandiesDraw2',
    component: () => import('@/activities/candies/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true,
      needLogin: true
    }
  },
  // // 618活动
  // {
  //   path: '/activity618',
  //   name: 'Activity618',
  //   component: () => import('@/activities/activity618/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 端午活动
  // {
  //   path: '/dragon-boat2',
  //   name: 'DragonBoat2',
  //   component: () => import('@/activities/dragon-boat2/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 积分排名二期活动
  // {
  //   path: '/score-board2',
  //   name: 'Scoreboard2',
  //   component: () => import('@/activities/score-board2/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // 收入贈送好友活動
  {
    path: '/gift-amount',
    name: 'GiftAmount',
    component: () => import('@/activities/gift-amount/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true
    }
  },
  // 糖果排名活动
  {
    path: '/candies-draw3',
    name: 'CandiesDraw3',
    component: () => import('@/activities/candies-draw3/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true,
      needLogin: true
    }
  },
  // // 绿色情人节活动
  // {
  //   path: '/green-valentine-day',
  //   name: 'GreenValentineDay',
  //   component: () => import('@/activities/green-valentine-day/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 七夕情人节活动
  // {
  //   path: '/valentine-day-qixi',
  //   name: 'ValentineDayQixi',
  //   component: () => import('@/activities/valentine-day-qixi/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 积分排名三期活动
  // {
  //   path: '/score-board3',
  //   name: 'Scoreboard3',
  //   component: () => import('@/activities/score-board3/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // 糖果排名活动
  {
    path: '/candies-draw4',
    name: 'CandiesDraw4',
    component: () => import('@/activities/candies-draw4/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true,
      needLogin: true
    }
  },
  // // 頭像框活動-聽歌開小火箭
  // {
  //   path: '/avatar-frame-rocket',
  //   name: 'AvatarFrameRocket',
  //   component: () => import('@/activities/avatar-frame-rocket/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true,
  //     needLogin: true
  //   }
  // },
  // // 中秋国庆活动
  // {
  //   path: '/moon-festival',
  //   name: 'MoonFestival',
  //   component: () => import('@/activities/moon-festival/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true,
  //     needLogin: true
  //   }
  // },
  // // 积分排名四期活动
  // {
  //   path: '/score-board4',
  //   name: 'Scoreboard4',
  //   component: () => import('@/activities/score-board4/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 双十活动（神魔）
  // {
  //   path: '/national-day',
  //   name: 'NationalDay',
  //   component: () => import('@/activities/national-day/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // 糖果抽奖活动
  {
    path: '/candies-draw5',
    name: 'CandiesDraw5',
    component: () => import('@/activities/candies-draw5/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true,
      needLogin: true
    }
  },
  // // 聖誕節活動
  // {
  //   path: '/christmas2',
  //   name: 'Christmas2',
  //   component: () => import('@/activities/christmas2/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true,
  //     needLogin: true
  //   }
  // },
  // // 星座活動
  // {
  //   path: '/constellation',
  //   name: 'Constellation',
  //   component: () => import('@/activities/constellation/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true,
  //     needLogin: true
  //   }
  // },
  // // 积分排名五期活动
  // {
  //   path: '/score-board5',
  //   name: 'Scoreboard5',
  //   component: () => import('@/activities/score-board5/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 开宝箱活动（橙色狂歡）
  // {
  //   path: '/orange-valentine-day',
  //   name: 'OrangeValentineDay',
  //   component: () => import('@/activities/orange-valentine-day/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true,
  //     needLogin: true
  //   }
  // },
  // // 积分排名六期活动
  // {
  //   path: '/score-board6',
  //   name: 'Scoreboard6',
  //   component: () => import('@/activities/score-board6/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 星座活動(射手座)
  // {
  //   path: '/constellation2',
  //   name: 'Constellation2',
  //   component: () => import('@/activities/constellation2/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true,
  //     needLogin: true
  //   }
  // },
  // 糖果抽奖活动6
  {
    path: '/candies-draw6',
    name: 'CandiesDraw6',
    component: () => import('@/activities/candies-draw6/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true,
      needLogin: true
    }
  },
  // 传奇商店
  {
    path: '/legendary-store',
    name: 'LegendaryStore',
    component: () => import('@/activities/legendary-store/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true,
      needLogin: true
    }
  },
  // // 积分排名六期活动
  // {
  //   path: '/christmas3',
  //   name: 'Christmas3',
  //   component: () => import('@/activities/christmas3/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 星座活動(摩羯座)
  // {
  //   path: '/constellation3',
  //   name: 'Constellation3',
  //   component: () => import('@/activities/constellation3/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true,
  //     needLogin: true
  //   }
  // },
  // // 年度盛典
  // {
  //   path: '/annual-celebration',
  //   name: 'AnnualCelebration',
  //   component: () => import('@/activities/annual-celebration/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true,
  //     needLogin: true
  //   }
  // },
  // // 年度盛典
  // {
  //   path: '/new-year-2024',
  //   name: 'NewYear2024',
  //   component: () => import('@/activities/new-year-2024/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true,
  //     needLogin: true
  //   }
  // },
  // 语音厅规则
  {
    path: '/voice-room-rule',
    name: 'VoiceRoomRule',
    component: () => import('@/activities/voice-room-rule/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true
    }
  },
  // // 积分排名7期活动(浪漫同行)
  // {
  //   path: '/score-board7',
  //   name: 'Scoreboard7',
  //   component: () => import('@/activities/score-board7/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 积分排名8期活动(浪漫同行)
  // {
  //   path: '/score-board8',
  //   name: 'Scoreboard8',
  //   component: () => import('@/activities/score-board8/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 开宝箱活动（欢乐日记）
  // {
  //   path: '/open-treasure-chest-diary',
  //   name: 'OpenTreasureChestDiary',
  //   component: () => import('@/activities/open-treasure-chest-diary/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 星座活動(水瓶座)
  // {
  //   path: '/constellation4',
  //   name: 'Constellation4',
  //   component: () => import('@/activities/constellation4/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true,
  //     needLogin: true
  //   }
  // },
  // // 星座活動(水瓶座)
  // {
  //   path: '/starry-sky',
  //   name: 'StarrySky',
  //   component: () => import('@/activities/starry-sky/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true,
  //     needLogin: true
  //   }
  // },
  // 糖果抽奖活动7
  // {
  //   path: '/candies-draw7',
  //   name: 'CandiesDraw7',
  //   component: () => import('@/activities/candies-draw7/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true,
  //     needLogin: true
  //   }
  // },
  // 星座活動(水瓶座)
  // {
  //   path: '/lantern-festival',
  //   name: 'LanternFestival',
  //   component: () => import('@/activities/lantern-festival/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // 星座活動(水瓶座)
  // {
  //   path: '/constellation5',
  //   name: 'Constellation5',
  //   component: () => import('@/activities/constellation5/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true,
  //     needLogin: true
  //   }
  // },
  // 积分排名8期活动(浪漫同行)
  // {
  //   path: '/score-board9',
  //   name: 'Scoreboard9',
  //   component: () => import('@/activities/score-board9/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // 糖果抽奖活动8
  // {
  //   path: '/candies-draw8',
  //   name: 'CandiesDraw8',
  //   component: () => import('@/activities/candies-draw8/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true,
  //     needLogin: true
  //   }
  // },
  // 玫瑰抽奖活动
  // {
  //   path: '/rose-draw',
  //   name: 'RoseDraw',
  //   component: () => import('@/activities/rose-draw/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true,
  //     needLogin: true
  //   }
  // },
  // 星座活動(水瓶座)
  // {
  //   path: '/constellation6',
  //   name: 'Constellation6',
  //   component: () => import('@/activities/constellation6/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true,
  //     needLogin: true
  //   }
  // },
  // 愚人节抽奖活动
  // {
  //   path: '/april-fools-day',
  //   name: 'AprilFoolsDay',
  //   component: () => import('@/activities/april-fools-day/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true,
  //     needLogin: true
  //   }
  // },
  // 积分排名10期活动(浪漫积分)
  // {
  //   path: '/score-board10',
  //   name: 'Scoreboard10',
  //   component: () => import('@/activities/score-board10/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // 兒童節
  // {
  //   path: '/children-day',
  //   name: 'ChildrenDay',
  //   component: () => import('@/activities/children-day/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // 鲜花抽奖活动
  // {
  //   path: '/flower-draw',
  //   name: 'FlowerDraw',
  //   component: () => import('@/activities/flower-draw/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 星座活動(守護金牛)
  // {
  //   path: '/constellation7',
  //   name: 'Constellation7',
  //   component: () => import('@/activities/constellation7/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // 五一抽獎活動
  // {
  //   path: '/may-day',
  //   name: 'MayDay',
  //   component: () => import('@/activities/may-day/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true,
  //     needLogin: true
  //   }
  // },
  // 积分11期排名活动（仲夏積分賽）
  // {
  //   path: '/score-board11',
  //   name: 'Scoreboard11',
  //   component: () => import('@/activities/score-board11/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // 母亲节
  // {
  //   path: '/mother-day',
  //   name: 'MotherDay',
  //   component: () => import('@/activities/mother-day/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // 暴击宝箱
  {
    path: '/critical-chests',
    name: 'CriticalChests',
    component: () => import('@/activities/critical-chests/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true
    }
  },
  // 520活动
  // {
  //   path: '/love520',
  //   name: 'Love2024',
  //   component: () => import('@/activities/love-2024/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // 星座活動(双子座)
  // {
  //   path: '/constellation8',
  //   name: 'Constellation8',
  //   component: () => import('@/activities/constellation8/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // 屠龍活动
  {
    path: '/slaying-dragons',
    name: 'SlayingDragons',
    component: () => import('@/activities/slaying-dragons/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true,
      needLogin: true
    }
  },
  // 积分12期排名活动（仲夏-夏至積分賽）
  // {
  //   path: '/score-board12',
  //   name: 'Scoreboard12',
  //   component: () => import('@/activities/score-board12/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // 端午節
  // {
  //   path: '/dragon-boat-festival',
  //   name: 'DragonBoatFestival',
  //   component: () => import('@/activities/dragon-boat-festival/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 寶箱送禮
  // {
  //   path: '/treasure-chest',
  //   name: 'TreasureChest',
  //   component: () => import('@/activities/treasure-chest/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 星座活動(巨蟹座)
  // {
  //   path: '/constellation9',
  //   name: 'Constellation9',
  //   component: () => import('@/activities/constellation9/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // // 积分13期排名活动（浪漫之夜積分賽）
  // {
  //   path: '/score-board13',
  //   name: 'Scoreboard13',
  //   component: () => import('@/activities/score-board13/index.vue'),
  //   meta: {
  //     hideNav: true,
  //     pageWidth: '100%',
  //     needMedia: true
  //   }
  // },
  // 糖果抽奖活动9
  {
    path: '/candies-draw9',
    name: 'CandiesDraw9',
    component: () => import('@/activities/candies-draw9/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true,
      needLogin: true
    }
  },
  // 星座活動(狮子座)
  {
    path: '/constellation10',
    name: 'Constellation10',
    component: () => import('@/activities/constellation10/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true
    }
  },
  // 积分14期排名活动（浪漫之夜積分賽）
  {
    path: '/score-board14',
    name: 'Scoreboard14',
    component: () => import('@/activities/score-board14/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true
    }
  },
  {
    path: '/valentine-day-2024',
    name: 'ValentineDay2024',
    component: () => import('@/activities/valentine-day-2024/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true
    }
  },
  // 星座活動(處女座)
  {
    path: '/constellation11',
    name: 'Constellation11',
    component: () => import('@/activities/constellation11/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true
    }
  },
  // 积分14期排名活动（浪漫之夜積分賽）
  {
    path: '/score-board15',
    name: 'Scoreboard15',
    component: () => import('@/activities/score-board15/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true
    }
  },
  // 中秋节
  {
    path: '/mid-autumn-festival',
    name: '/midAutumnFestival',
    component: () => import('@/activities/mid-autumn-festival/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true,
      needLogin: true
    }
  },
  // 星座活動(天秤座)
  {
    path: '/constellation12',
    name: 'Constellation12',
    component: () => import('@/activities/constellation12/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true
    }
  },
  // 积分16期排名活动（蔚藍積分賽）
  {
    path: '/score-board16',
    name: 'Scoreboard16',
    component: () => import('@/activities/score-board16/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true
    }
  },
  // 糖果抽奖活动10
  {
    path: '/candies-draw10',
    name: 'CandiesDraw10',
    component: () => import('@/activities/candies-draw10/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true,
      needLogin: true
    }
  },
  // 萬聖節
  {
    path: '/halloween2024',
    name: 'Halloween2024',
    component: () => import('@/activities/halloween2024/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true,
      needLogin: true
    }
  },
  // 星座活動(天秤座)
  {
    path: '/constellation13',
    name: 'Constellation13',
    component: () => import('@/activities/constellation13/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true
    }
  },
  // 万圣节大赛
  {
    path: '/contribute-halloween',
    name: 'ContributeHalloween',
    component: () => import('@/activities/contribute/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true,
      needLogin: true
    }
  },
  // 万圣节大赛排名
  {
    path: '/contribute-halloween-rank/:type',
    name: 'ContributeHalloweenRank',
    component: () => import('@/activities/contribute/halloween-rank.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true,
      needLogin: true
    }
  },
  // 暴击宝箱
  {
    path: '/gift-update',
    name: 'GiftUpdate',
    component: () => import('@/activities/gift-update/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true
    }
  },
  //（心動積分賽）
  {
    path: '/score-board17',
    name: 'Scoreboard17',
    component: () => import('@/activities/score-board17/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true
    }
  },
  // 双十一活动
  {
    path: '/double-eleven-2024',
    name: 'DoubleEleven2024',
    component: () => import('@/activities/double-eleven-2024/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true
    }
  },
  // 投稿活動-天蠍之星
  {
    path: '/contribute-scorpio',
    name: 'ContributeScorpio',
    component: () => import('@/activities/contribute-scorpio/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true,
      needLogin: true
    }
  },
  // 投稿活動-天蠍之星-排名
  {
    path: '/contribute-scorpio-rank/:type',
    name: 'ContributeScorpioRank',
    component: () => import('@/activities/contribute-scorpio/rank.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true,
      needLogin: true
    }
  },
  // 投稿活動-射手之星
  {
    path: '/contribute-sagittarius',
    name: 'ContributeSagittarius',
    component: () => import('@/activities/contribute-sagittarius/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true,
      needLogin: true
    }
  },
  // 投稿活動-射手之星-排名
  {
    path: '/contribute-sagittarius-rank/:type',
    name: 'ContributeSagittarius',
    component: () => import('@/activities/contribute-sagittarius/rank.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true,
      needLogin: true
    }
  },
  // 星座活動(天秤座)
  {
    path: '/constellation14',
    name: 'Constellation14',
    component: () => import('@/activities/constellation14/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true
    }
  },
  //（圣诞積分賽）
  {
    path: '/score-board18',
    name: 'Scoreboard18',
    component: () => import('@/activities/score-board18/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true
    }
  }
];
